import { render } from "./RequestDetails.vue?vue&type=template&id=a88142f4&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetails.vue?vue&type=script&lang=js"

import "./RequestDetails.vue?vue&type=style&index=0&id=a88142f4&scoped=true&lang=css"

import exportComponent from "/kaam/build/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88142f4"]])

export default __exports__